import { Link } from 'react-router-dom'
import { ArrowRight, CheckCircle2 } from 'lucide-react'
import AnimatedSection from '@/components/AnimatedSection'

const strengths = [
  'Licensed survey practice',
  'Modern field technology',
  'Clear, approval-ready reporting',
  '500+ completed projects',
]

export default function AboutSnippet() {
  return (
    <section className="overflow-hidden bg-white py-20 lg:py-24">
      <div className="section-padding mx-auto max-w-7xl">
        <div className="grid gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-center lg:gap-16">
          <AnimatedSection className="relative" direction="left">
            <div className="absolute -left-5 -top-5 hidden h-36 w-36 border border-accent/60 lg:block" />
            <div className="relative overflow-hidden rounded-2xl bg-black shadow-xl">
              <img
                src="/images/others/land-survey.png"
                alt="Surveying professionals reviewing site measurements"
                className="h-[320px] w-full object-cover opacity-90 sm:h-[400px]"
              />
              <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(0,0,0,0.02)_0%,rgba(0,0,0,0.58)_100%)]" />
              <div className="absolute bottom-5 left-5 bg-black/85 px-5 py-4 text-white backdrop-blur sm:bottom-6 sm:left-6">
                <div className="text-2xl font-semibold text-accent">15+ Years</div>
                <div className="mt-1 text-xs uppercase tracking-[0.16em] text-neutral-300">of trusted practice</div>
              </div>
            </div>
          </AnimatedSection>

          <AnimatedSection delay={0.1} direction="right">
            <span className="inline-flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.22em] text-accent-dark">
              {/* <span className="h-px w-10 bg-accent-dark" /> */}
              About Advict
            </span>

            <h2 className="mt-5 max-w-2xl text-3xl font-semibold leading-tight text-black sm:text-4xl lg:text-[2.7rem]">
              Precision surveying for property & development confidence.
            </h2>

            <p className="mt-6 max-w-2xl text-base leading-8 text-neutral-600">
              Advict Spatial Consult combines disciplined fieldwork with spatial analysis to help
              clients establish boundaries, verify site conditions, and document projects with confidence.
            </p>

            <ul className="mt-7 grid gap-3 sm:grid-cols-2">
              {strengths.map((item) => (
                <li key={item} className="flex items-center gap-3 text-sm font-medium text-neutral-800">
                  <CheckCircle2 className="h-5 w-5 flex-shrink-0 text-accent-dark" />
                  {item}
                </li>
              ))}
            </ul>

            <div className="mt-8 flex items-center gap-8 border-t border-neutral-200 pt-6">
              <div>
                <div className="font-serif text-2xl font-semibold text-black">500+</div>
                <div className="text-xs text-neutral-500">Projects delivered</div>
              </div>
              <div>
                <div className="font-serif text-2xl font-semibold text-black">Nigeria-wide</div>
                <div className="text-xs text-neutral-500">Service coverage</div>
              </div>
            </div>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <Link to="/about" className="btn-secondary">
                Learn More
                <ArrowRight className="h-4 w-4" />
              </Link>
              <Link to="/contact" className="btn-outline">
                Request a Survey
              </Link>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  )
}
